import {handleActions} from 'redux-actions';
import {MEDIA_ORDERS_LIST_SET, MEDIA_ORDERS_LIST_RESET} from './MediaOrdersListActions';
import {checkForNullAndFormat} from 'QCWorkflow/QCManager/Redux/QCManagerReducer';
import {MediaOrdersListItem} from '../MediaOrdersListTypes';

export const formatRow = (row: MediaOrdersListItem) => {
    const {dateIssued, createdAt, ...rest} = row;

    return {
        ...rest,
        dateIssued: checkForNullAndFormat(dateIssued),
        createdAt: checkForNullAndFormat(createdAt),
    };
};

interface State {
    rows: MediaOrdersListItem[];
    total: number;
}

interface SetItemsPayload {
    payload: State;
}

export const setItems = (state: State, {payload}: SetItemsPayload) => {
    const {rows, total} = payload;

    if (rows)
        return {
            rows: rows.map(formatRow),
            total,
        };

    return state;
};

export const resetItems = () => {
    return initialState;
};

const initialState = {
    rows: [],
    total: 0,
};

const handlers = {
    [MEDIA_ORDERS_LIST_SET]: setItems,
    [MEDIA_ORDERS_LIST_RESET]: resetItems,
};

export default handleActions(handlers, initialState);
